import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { HelpBoxBadgeComponent } from '@frontend/sports/help-box/feature';

@Component({
    selector: 'ms-bog-help-badge',
    template: ` <ms-help-box-badge class="best-odds" [text]="sitecore.horseRacing.badges.BOG" /> `,
    imports: [HelpBoxBadgeComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BestOddsGuaranteeBadgeComponent {
    readonly sitecore = inject(Sitecore);
}
